export const SET_COVER_URL = 'cover/SET_COVER_URL';
export const SET_NEW_COVER_URL = 'cover/SET_NEW_COVER_URL';
export const HANDLE_COVER_UPLOAD = 'cover/HANDLE_COVER_UPLOAD';
export const GET_PREDEFINED_IMAGE = 'cover/GET_PREDEFINED_IMAGE';
export const SET_PREDEFINED_IMAGE = 'cover/SET_PREDEFINED_IMAGE';
export const SET_IMAGE_SIZE = 'cover/SET_IMAGE_SIZE';
export const GET_IS_PREDEFINED_IMAGE = 'cover/IS_PREDEFINED_IMAGE';
export const SET_IS_PREDEFINED_IMAGE = 'cover/SET_PREDEFINED_IMAGE';
